import { mapGetters } from "vuex";

/**
 * A common set of functions to logging user out if not logged in
 */
export const authMixin = {
  computed: {
    ...mapGetters({
      checkSession: "checkSession"
    })
  },
  watch: {
    /**
     * Continuously checkin session (local) so that user can be logged out as soon as session is has expired.
     * When session expires, then user details are cleared from the local storage
     */
    checkSession(val) {
      if (!val) {
        this.$router.push("/login");
      }
    }
  }
};
